import React from 'react';
import SelectComponent from '../../../../../muiComponents/Select';
import { useZitoneoHotelRooms } from '../../../contexts/ZitoneoContentContext';
import { useZitoneoUI } from '../../../contexts/ZitoneoUIContext';

const RoomSelector = () => {
    const { rooms } = useZitoneoHotelRooms();
    const { selectedRoomId, handleSelectRoom } = useZitoneoUI();

    const handleHotelChange = (event: React.ChangeEvent<{ value: string }>) => {
        const selectedId = event.target.value;
        const selectedRoomObj = rooms.find(
            room => parseInt(room.Id) === parseInt(selectedId)
        );
        if (selectedRoomObj) handleSelectRoom(selectedRoomObj.Id);
    };

    return (
        <>
            {rooms.length ? (
                <div className='zitoneo-header__hotel-selector__container'>
                    <SelectComponent
                        className='zitoneo-header__room-select'
                        options={rooms}
                        optionsLabelKey='Label'
                        value={selectedRoomId || ''}
                        onChange={handleHotelChange}
                        required
                    />
                </div>
            ) : (
                ''
            )}
        </>
    );
};

export default RoomSelector;
